let state = {

}

export default state
